// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['lodash4', 'react', 'react-router-dom',
    '/www/lum/pub/styled.js', '/www/lum/pub/util/general.js', '/util/url.js'],
    (_, React, {Link, useHistory}, styled, {img_url}, zurl)=>
{
const {useEffect, useMemo} = React;

const E = {};

E.withExtLink = Comp=>{
    return styled(Comp)`${props=>!!props.ext_link && styled.css`
        &${Comp}:after {
            content: ' ';
            display: block;
            margin-left: 6px;
            width: 12px;
            height: 12px;
            mask-size: contain;
            mask-repeat: no-repeat;
            mask-position: center;
            mask-image: url('${img_url('ic_open_in_window.svg')}');
            background-color: ${({theme: {color}})=>color.icon_accent};
            &:hover { 
              background-color: ${({theme: {color}})=>color.icon_accent};
            }
        }
    `}`;
};

function fromTheme(propName, defaultValue){
  return function({theme, ...props}){
    let value = props[propName]??props[`$${propName}`]??defaultValue;
    if (value!=null)
    {
      if (propName.indexOf('padding')==0||propName.indexOf('margin')==0||
        ['gap', 'rowGap', 'columnGap'].includes(propName))
      {
        return theme.spacing[value]??value;
      }
      if (['font_family', 'font_weight', 'font_size', 'line_height',
        'letter_spacing', 'color'].includes(propName))
      {
        return theme[propName][value];
      }
      if (propName=='box_shadow')
        return theme.shadow[value]??theme.box_shadow[value];
    }
    return value;
  };
}
E.fromTheme = fromTheme;

E.getTo = (to, {history, preserveQueryParams: params})=>{
    if (to && (_.isString(to) || _.isObject(to)) && params)
    {
        let current_qs = zurl.qs_parse(history.location.search.substring(1));
        if (typeof params=='object' && Object.keys(params).length > 0)
        {
            current_qs = _.reduce(params,
                (acc, _v, key)=>{
                    const v = current_qs[key];
                    return typeof v=='undefined' ? acc : {...acc, [key]: v};
                },
                {});
        }
        let pathname, qs, cur = {};
        if (_.isString(to))
        {
            pathname = zurl.parse(to).pathname;
            qs = zurl.qs_parse_url(to);
        }
        else
        {
            pathname = to.pathname;
            qs = str_to_qs(to.search);
            cur = to;
        }
        return {
            ...cur,
            pathname,
            search: zurl.qs_str({...current_qs, ...qs}),
        };
    }
    return to;
};
const str_to_qs = s=>s ? zurl.qs_parse(s[0]=='?' ? s.substring(1) : s) : {};

E.getAriaProps = props=>_.pickBy(props, (_v, k)=>k.startsWith('aria-'));
E.getDataProps = props=>_.pickBy(props, (_v, k)=>k.startsWith('data-'));
E.getCommonProps = props=>Object.assign({},
    _.pick(props, 'id', 'className', 'style', 'onClick', 'tabIndex',
        'onGotPointerCapture', 'onLostPointerCapture'),
    _.pickBy(props, (_v, k)=>k.startsWith('onMouse')),
    _.pickBy(props, (_v, k)=>k.startsWith('onPointer')),
    E.getAriaProps(props),
    E.getDataProps(props),
);

E.getLinkProps = ({to, href, as, disabled, newTab, download, location,
    preserveQueryParams})=>
{
    let p = {as};
    if (to&&!disabled)
    {
        p = {...p, as: Link,
            to: E.getTo(to, {preserveQueryParams, history: {location}})};
    }
    else if (href&&!disabled)
        p = {...p, as: 'a', href};
    if (newTab)
        p = {...p, target: '_blank', rel: 'noopener noreferrer'};
    else if (download)
    {
        p = {...p, target: '_blank', rel: 'noopener noreferrer',
            download: typeof download=='string' ? download : true};
    }
    return p;
};

E.useLinkProps = opt=>{
    const location = useHistory()?.location;
    return useMemo(()=>E.getLinkProps({...opt, location}), [opt, location]);
};

E.useResize = cb=>{
    useEffect(()=>{
        const handleResize = _.throttle(cb, 100);
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, [cb]);
};

return E;
});
